// 事前審査開始認証
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Block from '../../molecules/Block';
import Annotation from '../../atoms/Annotation';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import Heading from '../../molecules/Heading';
import Text from '../../molecules/Text';
import TransitionButton from '../../molecules/TransitionButton';
import { http_status_code_list } from '../../Const';
import { isBrowserIe } from '../../BrowserJudgment';

const PreliminaryAuthenticate = () => {
  // 入力値を格納する
  const [authenticate_code, setAuthenticateCode] = useState<string>('');
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState<boolean>(false);
  // エラーメッセージ
  const [error_authenticate_code, setErrorAuthenticateCode] = useState<string>('');

  const node = document.getElementById('preliminary-authenticate');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // 「認証コードを送信する」ボタン押下時
  const executeAuthenticateCode = async () => {
    try {
      setErrorAuthenticateCode('');
      setIsLoading(true);

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/applicant/execute_authenticate`,
        {
          authenticate_code,
        }
      );

      location.replace(response.data.detail.url);
    } catch (error) {
      console.error(error);
      if (error.response.data.statusCode === http_status_code_list.unauthorized) {
        // バリデーションエラーの場合
        setErrorAuthenticateCode(error.response.data.message);
      } else {
        // システムエラー
        alert(error.response.data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // 「戻る」ボタン押下時
  const backTransition = () => {
    if (isBrowserIe()) {
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <>
      <Heading label="事前審査申込" bold={true} size="l" />
      <Block
        label="認証コード入力"
        content={
          <>
            <div className="container-box">
              <div>
                <div className="p-lead my-3">
                  受信したメールに表示されている認証コードをご入力下さい。
                  <br />
                  認証コードの有効期限はメール発行後30分です。
                </div>
                <div className="mt-3">
                  <Text
                    id="authenticate_code"
                    label="認証コード"
                    type="text"
                    value={authenticate_code}
                    placeholder=""
                    handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setAuthenticateCode(event.target.value);
                    }}
                    disabled={false}
                    message={error_authenticate_code}
                    display_border={true}
                  />
                </div>
                <div className="p-lead my-3">
                  確認メールは「no-reply@entry.ja-netloan.jp」から送信されます。
                  <br />
                  メールが届かない場合、メールアドレスのご確認、「no-reply@entry.ja-netloan.jp」から受信可能なメール設定であるかのご確認をいただき、前のページから再度送信をお願いいたします。
                </div>
                <div className="content-box">
                  <button
                    className="c-btn btn-max btn-green btn-arrow-right mx-auto mb-5"
                    type="button"
                    onClick={executeAuthenticateCode}
                  >
                    認証コードを送信する
                  </button>
                  <div>
                    <TransitionButton label="戻る" handleClick={backTransition} />
                  </div>
                </div>
                <LoadingModal show={is_loading} />
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

if (document.getElementById('preliminary-authenticate')) {
  render(<PreliminaryAuthenticate />, document.getElementById('preliminary-authenticate'));
}
